import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import Pricing from './Pricing';
import baseStyles from '../../styles/app.scss';
import s from './ProductPage.scss';

class ProductPage extends React.Component {
  static propTypes = {
    headerImg: PropTypes.string.isRequired,
    logoImg: PropTypes.string.isRequired,
    productName: PropTypes.any.isRequired, // eslint-disable-line react/forbid-prop-types
    productDescription: PropTypes.any.isRequired, // eslint-disable-line react/forbid-prop-types
    pricing: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.any,
        monthlyPrice: PropTypes.any,
        monthlyPayment: PropTypes.any,
        limitMessage: PropTypes.any,
        featureHeaderText: PropTypes.any,
        featureList: PropTypes.array,
        notesList: PropTypes.array,
        buyLink: PropTypes.string,
      }),
    ).isRequired,
  };

  static defaultProps = {
    tagline: '',
    pricing: [],
  };

  render() {
    const { headerImg, logoImg, productName, productDescription } = this.props;
    return (
      <div className={s.container}>
        <div className={s.header}>
          <img className={s.logoImg} src={logoImg} alt="" />
          <h1>
            {productName}
          </h1>
        </div>
        <div className={s.subline}>
          <h2>
            {productDescription}
          </h2>
        </div>

        <img className={s.headerImg} src={headerImg} alt="" />
        <Pricing pricing={this.props.pricing} />
      </div>
    );
  }
}

export default withStyles(baseStyles, s)(ProductPage);



// WEBPACK FOOTER //
// ./src/components/ProductPage/index.js